<template>
  <div
    :class="[
      'position-fixed w-100 bg-white add-to-basket-sticky py-2',
      { 'slide-up': !isVisible, 'slide-up-active': isVisible },
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "add-to-basket-sticky",
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    handleVisibilityChange(entries) {
      const [entry] = entries;
      this.isVisible = entry.boundingClientRect.bottom < 0;
    },
  },
  watch: {
    isVisible(newValue) {
      if (newValue) {
        document.body.classList.add("basket-sticky-visible");
      } else {
        document.body.classList.remove("basket-sticky-visible");
      }
    },
  },
  mounted() {
    const addToCartButton = document.getElementById("addToCartButton");

    this.observer = new IntersectionObserver(this.handleVisibilityChange, {
      root: null,
      threshold: 0,
    });

    if (addToCartButton) {
      this.observer.observe(addToCartButton);
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>
